import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import AmericanQuotesBox from "components/company/v3/american/boxes/AmericanQuotesBox";
import AmericanPageLayout from "components/company/v3/layouts/AmericanPageLayout";
import { CompanyQuotesTabEnum } from "components/company/v3/menu/enums";
import AmericanIssuerSeo from "components/company/v3/seo/AmericanIssuerSeo";
import IssuerHeaderByTickerSymbol from "components/issuers/IssuerHeaderByTickerSymbol";
import useSelfie from "lib/hooks/useSelfie";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import { useIntl } from "react-intl";
import { ISecurityCountry } from "types/graphqlTypes";
import { format } from "util";

interface AmericanQuotesPageProps {
  tickerSymbol: string | null;
}

const AmericanQuotesPage: NextPage<AmericanQuotesPageProps> = function AmericanQuotesPage({ tickerSymbol }) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyQuotesTabEnum>(Object.values(CompanyQuotesTabEnum)).withDefault(
      CompanyQuotesTabEnum.QUOTE,
    ),
  );
  const viewer = useSelfie();
  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <AmericanPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="Stocks" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <>
          <AmericanIssuerSeo
            title={intl.formatMessage({
              defaultMessage: "Cotação",
              description: "Título da página - SEO",
              id: "d+IfD/",
            })}
          />
          {!viewer && (
            <IssuerHeaderByTickerSymbol
              country={ISecurityCountry.Us}
              tickerSymbol={normalizedTickerSymbol}
              className="pb-6"
              title={intl.formatMessage({ defaultMessage: "Cotação", id: "zV6SED" })}
              description={intl.formatMessage({
                defaultMessage: "Gráfico histórico de cotação e retorno anual dos últimos anos",
                id: "SaNBkr",
              })}
            />
          )}
          <AmericanQuotesBox
            key={format("quotes/%s/%s", normalizedTickerSymbol, tab)}
            tickerSymbol={normalizedTickerSymbol}
            tab={tab}
            onChangeTab={setTab}
          />
        </>
      </WrapperAmplitudeCompanyTab>
    </AmericanPageLayout>
  );
};

AmericanQuotesPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default AmericanQuotesPage;
